import { render } from "./CompanyMenu.vue?vue&type=template&id=37df5423"
const script = {}

import "./CompanyMenu.vue?vue&type=style&index=0&id=37df5423&lang=css"

import exportComponent from "/codebuild/output/src327471177/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__